import { render, staticRenderFns } from "./Playphone.vue?vue&type=template&id=fabf1b8a"
import script from "./Playphone.vue?vue&type=script&lang=js"
export * from "./Playphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports